const preloadWidget = async (row, funcionalidade, authorization) => {
  const payload = {
    descricao: row.titulo,
    idDeclaracao: row.idDeclaracao,
    codigoTitulo: row.subTitulo
  }
  return createPayload(payload, funcionalidade, authorization)
}

function createPayload (detalhe, funcionalidade, authorization) {
  const payload = {
    'idFuncionalidade': funcionalidade.idFuncionalidade,
    'data': {
      ...detalhe
    },
    'configuracao': {
      'parametros': {},
      'metodoEnvio': []
    },
    'opcoesDeEnvio': []
  }
  if (funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioChatWidget) {
    payload.configuracao.metodoEnvio.push({
      'tipo': {
        'id': 1,
        'descricao': 'Mensagem no chat'
      },
      'sincrono': true
    })
  }
  if (funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioEmailWidget && funcionalidade.parametros.configuracoesDeWidgets.templateEnvioEmailWidget) {
    payload.configuracao.metodoEnvio.push({
      'tipo': {
        'id': 2,
        'descricao': 'E-mail'
      },
      'template': funcionalidade.parametros.configuracoesDeWidgets.templateEnvioEmailWidget,
      'sincrono': false
    })
  }
  if (funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioWhatsappWidget && funcionalidade.parametros.configuracoesDeWidgets.templateEnvioWhatsappWidget) {
    payload.configuracao.metodoEnvio.push({
      'tipo': {
        'id': 3,
        'descricao': 'WhatsApp'
      },
      'template': funcionalidade.parametros.configuracoesDeWidgets.templateEnvioWhatsappWidget,
      'sincrono': false
    })
  }
  payload.opcoesDeEnvio.push({
    'nome': funcionalidade.parametros.detalheDeclaracaoTituloNavegacao,
    'nomeIntegracao': 'detalhe',
    'integracao': {
      'headers': {
        'Authorization': authorization
      },
      'parametros': {},
      'rota': {
        ...funcionalidade.rotas.detalhe
      },
      'payload': {
        'idDeclaracao': detalhe.idDeclaracao
      }
    },
    'data': {
      'tituloWidget': `${detalhe.descricao}-${detalhe.codigoTitulo}`
    }
  })
  return payload
}
export { preloadWidget }
